import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import darkTheme from './theme';
import CockpitPage from './pages/CockpitPage';
import PartsPage from './pages/PartsPage';
import HistoryPage from './pages/HistoryPage';
import DocumentationPage from './pages/DocumentationPage';
import MSAStudyPage from './pages/MSAStudyPage';
import ComparePage from './pages/ComparePage';
import TierGate from './components/TierGate';
import NotFound from './components/NotFound';
import ErrorBoundary from './components/ErrorBoundary';
import SignInPage from './pages/SignInPage';
import SignUpPage from './pages/SignUpPage';
import { AUTH_ENABLED } from './authConfig';

function App() {
    return (
        <ThemeProvider theme={darkTheme}>
            <CssBaseline />
            <ErrorBoundary>
                <Routes>
                    {/* Cockpit (capability analysis) is the free tier — always open (ADR-007). */}
                    <Route path="/" element={<CockpitPage />} />

                    {/* AUTH-7: paid routes (history / MSA / compare — ADR-007), gated by the
                        real Clerk TierGate. The interim passcode wall (MSAGate / PasscodeGate)
                        was retired at the Phase C cutover — see §7c. */}
                    {/* TIER-3 Phase 1 (design doc §5, owner decision 7): Parts is a sibling
                        tab, gated the same way — Cockpit above stays the free/anon home. */}
                    <Route
                        path="/parts"
                        element={<TierGate feature="Parts & measurement streams"><PartsPage /></TierGate>}
                    />
                    <Route
                        path="/msa"
                        element={<TierGate feature="MSA & GRR studies"><MSAStudyPage /></TierGate>}
                    />
                    <Route
                        path="/history"
                        element={<TierGate feature="Saved analysis history"><HistoryPage /></TierGate>}
                    />
                    <Route
                        path="/compare"
                        element={<TierGate feature="Side-by-side study comparison"><ComparePage /></TierGate>}
                    />

                    {/* General how-to docs stay free (ADR-007). */}
                    <Route path="/documentation" element={<DocumentationPage />} />
                    {/* AUTH-4: Clerk sign-in/up routes, only when auth is enabled. */}
                    {AUTH_ENABLED && <Route path="/sign-in/*" element={<SignInPage />} />}
                    {AUTH_ENABLED && <Route path="/sign-up/*" element={<SignUpPage />} />}
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </ErrorBoundary>
        </ThemeProvider>
    );
}

export default App;
